import React, { useState, useEffect } from "react";
import { Modal, CircularProgress, Typography, Slider } from "@mui/material";
import Table from "@mui/material/Table";
import html2canvas from "html2canvas";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, TextField } from "@mui/material";
import ModelRankingTable from "./ModelRankingTable";

import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
  Brush,
} from "recharts";

import "./leftbar.css";

import { format, set } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const Purifiedlog = ({
  selectedMarker,
  setispurifiedModalOpen,
  purifiedDatalogs,
  setpurifiedDatalogs,
  HelpModal,
  formatDate,
  helpOpen,
  setHelpOpen,
  handleClosepurifiedModal,
}) => {
  const [zoomLevelPurifiedDatalogs, setZoomLevelPurifiedDatalogs] = useState(0);
  const [startIndexPurifiedDatalogs, setStartIndexPurifiedDatalogs] =
    useState(0);
  const [endIndexPurifiedDatalogs, setEndIndexPurifiedDatalogs] = useState(
    purifiedDatalogs.length - 1,
  );

  useEffect(() => {
    setStartIndexPurifiedDatalogs(0);
    setEndIndexPurifiedDatalogs(purifiedDatalogs.length - 1);
  }, [purifiedDatalogs]);

  const handleZoomPurifiedDatalogs = (event, newValue) => {
    setZoomLevelPurifiedDatalogs(newValue);
    const range = purifiedDatalogs.length;

    const zoomFactor = newValue / 100;

    const newStart = Math.floor(range * zoomFactor * 0.5);
    const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

    setStartIndexPurifiedDatalogs(Math.max(0, newStart));
    setEndIndexPurifiedDatalogs(Math.min(purifiedDatalogs.length - 1, newEnd));
  };

  // Zoom In/Out & Reset for Purified Datalogs

  const handleZoomInPurifiedDatalogs = () => {
    setZoomLevelPurifiedDatalogs((prev) => Math.min(prev + 10, 100));
  };
  const handleZoomOutPurifiedDatalogs = () => {
    setZoomLevelPurifiedDatalogs((prev) => Math.max(prev - 10, 0));
  };
  const resetZoomPurifiedDatalogs = () => {
    setStartIndexPurifiedDatalogs(0);
    setZoomLevelPurifiedDatalogs(0);
    setEndIndexPurifiedDatalogs(purifiedDatalogs.length - 1);
  };
  const handleSort = (key) => {
    const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
    setSortConfig({
      ...sortConfig,
      [key]: { direction: newDirection },
    });
  };

  // Visible Data Calculation

  const visibleDataPureDatalogs = purifiedDatalogs.slice(
    startIndexPurifiedDatalogs,
    endIndexPurifiedDatalogs + 1,
  );

  const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level

  const [dataLimitPurifiedDatalogs, setDataLimitPurifiedDatalogs] = useState(
    visibleDataPureDatalogs.length,
  );

  // Apply the data limit to the visible data

  const handleDataLimitChangePureDtalogs = (event) => {
    setDataLimitPurifiedDatalogs(parseInt(event.target.value));
  };

  // Apply the data limit to the visible data
  const filteredDataPurifiedDatalogs = visibleDataPureDatalogs.slice(
    -dataLimitPurifiedDatalogs,
  );

  const [sortConfig, setSortConfig] = useState({
    mTm: { direction: "asc" },
    wtr: { direction: "asc" },
    // tmp: { direction: "asc" },
    // prs: { direction: "asc" },
  });

  const [versions, setVersions] = useState([]); // Store versions data from backend
  const [selectedVersion, setSelectedVersion] = useState(null); // Selected version number
  const [tableData, setTableData] = useState([]); // Store the fetched data for the selected version
  const [dataType, setDataType] = useState("imputed"); // default option
  const [imputedVersions, setImputedVersions] = useState([]);
  const [anomalyVersions, setAnomalyVersions] = useState([]);

  // State to store modal open state and version details
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [versionDetails, setVersionDetails] = useState(null);

  // Fetch versions based on selected wellId
  const fetchVersions = async (wellId) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs_versions/${wellId}`,
      );
      const data = await response.json();

      if (response.ok) {
        const impData = data.filter((item) => item.imp_or_anom === "imp");
        const anomData = data.filter((item) => item.imp_or_anom === "anom");

        setImputedVersions(impData); // Store imputed versions
        setAnomalyVersions(anomData); // Store anomaly versions
      } else {
        console.error("Error fetching versions:", data.error);
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
  };

  const fetchVersionDetails = async () => {
    let response;
    try {
      // Call the API to get the version details (here version 0 means the latest)
      if (dataType === "imputed") {
        response = await fetch(
          `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              imp_or_anom: "imp",
            },
          },
        );
      } else {
        response = await fetch(
          `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              imp_or_anom: "anom",
            },
          },
        );
      }
      const data = await response.json();

      console.log(data);

      if (response.ok) {
        setVersionDetails(data); // Store the received data in state
        setIsModalOpen(true); // Open the modal
      } else {
        console.error("Error fetching version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  // Handle version change in dropdown
  const handleVersionChange = async (event) => {
    const versionNumber = event.target.value;
    console.log("Selected version:", versionNumber);
    console.log("Selected wellId:", selectedMarker.wellId);
    setSelectedVersion(versionNumber); // Update selected version number
    let response;
    let data;

    try {
      // fetch for selected data type (imputed or anomaly corrected)
      if (dataType === "imputed") {
        response = await fetch(
          `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${selectedMarker.wellId}/${versionNumber}`,
        );
        data = await response.json();
        console.log("imputed data", data);
      } else if (dataType === "anomaly") {
        response = await fetch(
          `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`,
        );
        data = await response.json();
        console.log("anomaly data", data);
      }

      if (response.ok) {
        setTableData(data); // Keep this for consistency
        setpurifiedDatalogs(data); // Update the main datalogs state used by the graph and table

        // Reset zoom and visualization settings when changing versions
        resetZoomPurifiedDatalogs();
        setDataLimitPurifiedDatalogs(data.length); // Reset data limit to the new data length
      } else {
        console.error("Error fetching  data:", data.error);
        alert("Error fetching data for this version");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for this version");
    }
  };

  const handleDetailsButtonClick = () => {
    if (selectedVersion) {
      fetchVersionDetails(selectedMarker.wellId, selectedVersion); // Fetch details for the selected version
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  // Fetch versions on component mount or when selectedMarker changes
  useEffect(() => {
    if (selectedMarker && selectedMarker.wellId) {
      fetchVersions(selectedMarker.wellId); // Fetch versions when the wellId is available
    }
  }, [selectedMarker]);

  // Custom Dot Component
  const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_imputed) {
      return (
        <circle cx={cx} cy={cy} r={5} stroke="red" strokeWidth={2} fill="red" />
      );
    }

    return <circle cx={cx} cy={cy} r={5} fill="black" />;
  };

  const sortedpureDatalogs = [...purifiedDatalogs].sort((a, b) => {
    const key = Object.keys(sortConfig).find(
      (k) => sortConfig[k].direction !== "asc",
    );
    if (!key) return 0;
    const direction = sortConfig[key].direction === "asc" ? 1 : -1;
    if (a[key] < b[key]) return -1 * direction;
    if (a[key] > b[key]) return 1 * direction;
    return 0;
  });

  const imdownloadAsCSV = () => {
    const csv = Papa.unparse(purifiedDatalogs);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const fileName = `datalogs_${selectedMarker.wellId}_${dataType}_version_${selectedVersion}.csv`;
    saveAs(blob, fileName);
  };

  const imdownloadAsPDF = () => {
    const doc = new jsPDF();
    const tableData = purifiedDatalogs.map((datalog) => [
      datalog.mTm,
      datalog.wtr,
      datalog.is_imputed ? "Yes" : "No",
      datalog.is_anomaly_corrected ? "Yes" : "No",
    ]);

    doc.text("Datalogs", 14, 10);
    doc.autoTable({
      head: [
        [
          "Measurement Time",
          "Water Level",
          "Is Imputed?",
          "Is Anomaly Corrected?",
        ],
      ],
      body: tableData,
    });
    // save doc with version nuber and well id
    const versionNumber = selectedVersion || "latest";
    const wellId = selectedMarker.wellId || "unknown";
    const fileName = `datalogs_${wellId}_${dataType}_version_${versionNumber}.pdf`;
    doc.save(fileName);
  };

  const chartRef = React.useRef();
  const handleDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "PurifiedLog.png";
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  };

  // const handleDownload = () => {
  //   const chartElement = document.querySelector(".chart-container"); // Ensure correct selection
  //   if (!chartElement) {
  //     console.error("Chart element not found!");
  //     return;
  //   }

  //   setTimeout(() => {
  //     html2canvas(chartElement, { scale: 2, useCORS: true })
  //       .then((canvas) => {
  //         if (canvas) {
  //           canvas.toBlob((blob) => {
  //             if (blob) {
  //               saveAs(blob, "chart.png"); // Save as PNG (JPEG may cause quality loss)
  //             } else {
  //               console.error("Blob creation failed. Using DataURL instead.");
  //               const dataUrl = canvas.toDataURL("image/png");
  //               const link = document.createElement("a");
  //               link.href = dataUrl;
  //               link.download = "chart.png";
  //               link.click();
  //             }
  //           });
  //         } else {
  //           console.error("Canvas creation failed.");
  //         }
  //       })
  //       .catch((err) => console.error("html2canvas error:", err));
  //   }, 500); // Ensure the chart is fully rendered
  // };

  return (
    <div className="modal">
      <div className="modal-overlay" />
      <div className="modal-row">
        <div className="modal-content left-content">
          <div className="input-group">
            <div
              className="left-content-wrapper"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {/* First block: Well name and location (2 lines) */}
              <div className="well-info-container">
                <h2
                  style={{
                    marginBottom: "0px",
                    marginTop: "80px",
                    color: "red",
                    fontSize: "30px",
                  }}
                >
                  Imputed and Anomaly Corrected Data
                </h2>
                <h2
                  style={{
                    marginBottom: "0px",
                    marginTop: 0,
                    fontSize: "30px",
                  }}
                >
                  {selectedMarker.wellId}
                </h2>
                <p style={{ marginLeft: "80px" }}>
                  <strong>Location:</strong> {selectedMarker.union_},{" "}
                  {selectedMarker.upazilla}, {selectedMarker.district},{" "}
                  {selectedMarker.division}
                </p>
              </div>
              {/* Version details modal - keeping original design */}
              <Modal open={isModalOpen} onClose={handleCloseModal}>
                <div
                  style={{
                    position: "absolute",
                    top: "53%",
                    left: "74%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "cyan",
                    color: "black",
                    padding: "20px",
                    borderRadius: "8px",
                    minWidth: "400px",
                  }}
                >
                  <Typography variant="h6">Version Details</Typography>

                  {versionDetails ? (
                    <div>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Well ID:</strong> {versionDetails.wellId}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Version Number:</strong>{" "}
                        {versionDetails.version_number}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Update Time:</strong>{" "}
                        {formatDate(versionDetails.update_time)}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>
                          {dataType === "imputed"
                            ? "Imputation Date Range:"
                            : "Anomaly Correction Date Range:"}
                        </strong>{" "}
                        {formatDate(versionDetails.start_date, "d MMM yyyy")} to{" "}
                        {formatDate(versionDetails.end_date, "d MMM yyyy")}
                      </p>

                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Name:</strong> {versionDetails.name}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Designation:</strong>{" "}
                        {versionDetails.designation}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Email:</strong> {versionDetails.email}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Contact No:</strong> {versionDetails.contact_no}
                      </p>
                      <p style={{ color: "black", fontSize: "16px" }}>
                        <strong>Comments:</strong> {versionDetails.comments}
                      </p>
                    </div>
                  ) : (
                    <p>Loading...</p>
                  )}

                  {/* Close Button */}
                  <Button
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      width: "100px",
                    }}
                  >
                    Close
                  </Button>
                </div>
              </Modal>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  marginLeft: "70px",
                }}
              >
                {/* Dropdown to choose between Imputed and Anomaly Corrected Data */}
                <FormControl variant="outlined" style={{ width: "300px" }}>
                  <InputLabel id="data-type-label">Select Data Type</InputLabel>
                  <Select
                    labelId="data-type-label"
                    value={dataType}
                    onChange={(e) => {
                      setDataType(e.target.value);
                      setSelectedVersion(""); // reset version selection
                    }}
                    label="Select Data Type"
                  >
                    <MenuItem value="imputed">Imputed</MenuItem>
                    <MenuItem value="anomaly">Anomaly Corrected</MenuItem>
                  </Select>
                </FormControl>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    marginBottom: "0px",
                  }}
                >
                  <FormControl variant="outlined" style={{ width: "300px" }}>
                    {dataType === "imputed" ? (
                      <InputLabel id="imputed-version-label">
                        Select Version of Imputation
                      </InputLabel>
                    ) : (
                      <InputLabel id="anomaly-version-label">
                        Select Version of Anomaly Correction
                      </InputLabel>
                    )}
                    <Select
                      labelId="version-label"
                      value={selectedVersion}
                      onChange={handleVersionChange}
                      label={
                        dataType === "imputed"
                          ? "Select Version of Imputation"
                          : "Select Version of Anomaly Correction"
                      }
                      fullWidth
                    >
                      {(dataType === "imputed"
                        ? imputedVersions
                        : anomalyVersions
                      )
                        .sort((a, b) => a.version_number - b.version_number)
                        .map((version) => (
                          <MenuItem
                            key={version.version_number}
                            value={version.version_number}
                          >
                            {`[${version.measurement_parameters.join(", ")}] Version ${version.version_number} - ${format(
                              new Date(version.update_time),
                              "dd--MM--yyyy HH:mm:ss",
                            )}`}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDetailsButtonClick}
                  >
                    Details
                  </Button>
                </div>
              </div>

              {/* Graph section with original design but reduced spacing */}
              <div
                className="graph-container"
                style={{ marginBottom: "5px", marginRight: "5px" }}
              >
                <h3 style={{ margin: "0 0 3px 0" }}>
                  WTR (Water Level) VS mTm (Measurement Time)
                </h3>
                <div className="button-group" style={{ marginBottom: "3px" }}>
                  {/* <Button
                      variant="contained"
                      onClick={handleZoomInPurifiedDatalogs}
                      className="zoom-button"
                    >
                      Zoom In
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleZoomOutPurifiedDatalogs}
                      className="zoom-button"
                    >
                      Zoom Out
                    </Button> */}
                  <Button
                    variant="contained"
                    onClick={resetZoomPurifiedDatalogs}
                    className="zoom-button"
                  >
                    Reset Zoom
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDownload}
                    className="zoom-button"
                  >
                    Save Image
                  </Button>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    marginBottom: "3px",
                  }}
                >
                  <Slider
                    value={zoomLevelPurifiedDatalogs}
                    onChange={handleZoomPurifiedDatalogs}
                    aria-labelledby="zoom-slider"
                    min={0}
                    max={100}
                    step={5}
                    valueLabelDisplay="auto"
                    style={{ flex: 1 }}
                  />
                  <h3 style={{ minWidth: "50px", margin: 0 }}>
                    {zoomLevelPurifiedDatalogs}%
                  </h3>
                </div>

                <div
                  className="filter-container"
                  style={{ marginBottom: "3px" }}
                >
                  <h3 className="filter-label">Filter Data: </h3>
                  <FormControl
                    variant="outlined"
                    size="small"
                    className="filter-dropdown"
                  >
                    <InputLabel>Data Points</InputLabel>
                    <Select
                      value={dataLimitPurifiedDatalogs}
                      onChange={handleDataLimitChangePureDtalogs}
                      label="Data Points"
                    >
                      <MenuItem value={10}>Last 10</MenuItem>
                      <MenuItem value={50}>Last 50</MenuItem>
                      <MenuItem value={100}>Last 100</MenuItem>
                      <MenuItem value={visibleDataPureDatalogs.length}>
                        All
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <ResponsiveContainer width="100%" height={200}>
                  <LineChart
                    data={
                      filteredDataPurifiedDatalogs.length > 0
                        ? filteredDataPurifiedDatalogs
                        : []
                    }
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="mTm"
                      tickFormatter={(tick) =>
                        new Date(tick).toLocaleDateString()
                      }
                      label={{
                        value: "Measurement Time (mTm)",
                        position: "insideBottomRight",
                        offset: -10,
                      }}
                    />
                    <YAxis
                      domain={[0, 12]}
                      label={{
                        value: selectedMetric.toUpperCase(),
                        angle: -90,
                        position: "insideLeft",
                      }}
                    />
                    <Tooltip
                      contentStyle={{ color: "#fff" }}
                      labelFormatter={(value) => `Time: ${formatDate(value)}`}
                      formatter={(value, name) => [
                        `${value}`,
                        `${name.toUpperCase()}`,
                      ]}
                    />
                    <Line
                      type="monotone"
                      dataKey={selectedMetric}
                      stroke="#000000"
                      strokeWidth={2}
                      dot={<CustomDot />}
                    />
                    <Brush
                      dataKey="mTm"
                      height={30}
                      stroke="#8884d8"
                      tickFormatter={(tick) => new Date(tick).toLocaleString()}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-content right-content">
          <div style={{ marginBottom: "5px" }}>
            <div className="button-group" style={{ marginBottom: "5px" }}>
              <Button
                variant="contained"
                onClick={imdownloadAsCSV}
                className="blue-button"
              >
                Download as CSV
              </Button>
              <Button
                variant="contained"
                onClick={imdownloadAsPDF}
                className="green-button"
              >
                Download as PDF
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setHelpOpen(true)}
              >
                Help
              </Button>
              <Button
                variant="contained"
                onClick={handleClosepurifiedModal}
                className="red-button"
              >
                Close Window
              </Button>
            </div>

            <h2 style={{ margin: "0 0 3px 0" }}>
              Datalog for {selectedMarker.wellId}
            </h2>
            <p style={{ margin: "0 0 5px 0", marginLeft: "120px" }}>
              <strong>Location:</strong> {selectedMarker.union_},{" "}
              {selectedMarker.upazilla},{selectedMarker.district},{" "}
              {selectedMarker.division}
            </p>
          </div>

          {/* Help Modal */}
          <HelpModal open={helpOpen} handleClose={() => setHelpOpen(false)} />

          <p style={{ margin: "2px 0" }}>
            Click on the cell to sort it ASC <FaArrowUp /> or DESC{" "}
            <FaArrowDown />
          </p>

          {/* Table section - keeping original design with more space */}
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "#000000",
              padding: "10px",
              borderRadius: "8px",
            }}
          >
            <Table sx={{ minWidth: 650 }}>
              <TableHead sx={{ backgroundColor: "#ffffff" }}>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.mTm.direction !== "asc"}
                      direction={sortConfig.mTm.direction}
                      onClick={() => handleSort("mTm")}
                    >
                      Measurement Time
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.wtr.direction !== "asc"}
                      direction={sortConfig.wtr.direction}
                      onClick={() => handleSort("wtr")}
                    >
                      Water Level
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {dataType === "imputed"
                        ? "Is Imputed?"
                        : "Is Anomaly Corrected?"}
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedpureDatalogs.map((datalog) => (
                  <TableRow
                    key={datalog.id}
                    sx={{
                      backgroundColor: datalog.is_imputed
                        ? "#052d0a"
                        : "#1a1a1a",
                      "&:nth-of-type(odd)": {
                        backgroundColor: datalog.is_imputed
                          ? "#052d0a"
                          : "#262626",
                      },
                    }}
                  >
                    <TableCell sx={{ color: "#ffffff" }}>
                      {formatDate(datalog.mTm)}
                    </TableCell>
                    <TableCell sx={{ color: "#ffffff" }}>
                      {datalog.wtr}
                    </TableCell>
                    <TableCell sx={{ color: "#ffffff" }}>
                      {datalog.is_imputed ? "Yes" : "No"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default Purifiedlog;
